import React, {createContext, useCallback, useContext, useEffect, useRef, useState} from "react"
import {getClubMemberList, getDiscountList} from "../../../api/clubMemberList"
import {message} from "antd"

const initialState = {
    isLoading: false,
    page: {
        count: 10,
        page: 1,
        total: 0
    },
    searchKey: {
        keyword: null,
        keywordType: 1,
        discountId: null
    },
    memberList: [{
        account: '',
        discount: 0,
        discountId: 0,
        discountName: '',
        id: 0,
        isBound: false,
        isInBlacklist: false,
        isTemporary: false,
        memberName: '',
        nickName: '',
        profit: 0,
        registerTime: '',
        usedMoney: 0
    }],
    discountList: [{label: '暂无数据', value: 0, disable: true}],
    onSearchKeyChange: (keyword, keywordType, discountId) => {
    },
    onPageChange: (page) => {
    },
    fetchClubMemberList: async (page) => {
    },
    fetchDiscountList: async () => {
    }
}

export const ClubMemberContext = createContext(initialState)

export const ClubMemberContextProvider = (props) => {
    const [isLoading, setIsLoading] = useState(initialState.isLoading)
    const [page, setPage] = useState(initialState.page)
    const [searchKey, setSearchKey] = useState(initialState.searchKey)
    const [memberList, setMemberList] = useState([])
    const [discountList, setDiscountList] = useState(initialState.discountList)
    const firstUpdate = useRef(true)

    const onSearchKeyChange = (keyword, keywordType, discountId) => {
        setSearchKey(prevSearchKey => ({
            keyword: keyword !== null ? keyword : prevSearchKey.keyword,
            keywordType: keywordType !== null ? keywordType : prevSearchKey.keywordType,
            discountId: discountId !== null ? discountId : prevSearchKey.discountId
        }))
    }

    const onPageChange = (page, pageSize) => {
        setPage(prevState => {
            return {
                ...prevState,
                page: page,
                count: pageSize
            }
        })
    }

    const fetchClubMemberList = async () => {
        setIsLoading(true)
        console.log(page)
        await getClubMemberList(page.page, page.count, searchKey.keyword, searchKey.keywordType, searchKey.discountId).then(res => {
            setMemberList(res.data.values)
            setPage(prevState => {
                return {
                    ...prevState,
                    total: res.data.total
                }
            })
        }).catch(err => {
            message.error(err)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false
            return
        }
        if (searchKey.keyword.length!==0){
            setPage(prevState => {
                return {
                    ...prevState,
                    page: 1
                }
            })
        }
        fetchClubMemberList()
    }, [page.page,page.count, searchKey.keyword, searchKey.discountId])

    useEffect(() => {
        fetchDiscountList()
    }, [])


    const fetchDiscountList = async () => {
        await getDiscountList().then(res => {
            if (res.status !== 1) {
                message.error(res.detail)
                return
            }
            if (res.data.length !== 0) {
                setDiscountList(res.data.map(item => {
                    return {
                        label: item.name,
                        value: item.id
                    }
                }))
            }
        }).catch(err => {
            message.error(err)
        })
    }


    const value = {
        isLoading,
        page,
        searchKey,
        memberList,
        discountList,
        onSearchKeyChange,
        onPageChange,
        fetchClubMemberList,
        fetchDiscountList
    }

    return (
        <ClubMemberContext.Provider value={value}>
            {props.children}
        </ClubMemberContext.Provider>
    )
}

export const useClubMemberContext = () => {
    const context = useContext(ClubMemberContext)
    if (!context) {
        throw new Error("useClubMemberContext must be used within a ClubMemberContextProvider")
    }
    return context
}




// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/store/useClubMemberContext.js